import isMaterialWarehouse from '@/common/is-warehouse'
import {
  getCategoryName,
  isElementStars,
  isExpandedContent,
  isGameConfigStars,
  isLang,
} from '@/views/creative/utils'
import { hasPermission } from '@/views/creative/template/auth'
import _ from 'lodash'
import {
  categoryConfig,
  gameConfigCategoryResourceType,
} from '@/store/creative/common/category'

export default function getOutlineCategory({
  category,
  isDco,
  templateConfig,
  gameConfigResource,
  foldCategoryList,
  permissionKeys,
}) {
  const rec = (data, { level, parentCategoryId }) => {
    const isFold = (node) => {
      // 如果不折叠默认展开
      return foldCategoryList.some((j) => j === node.id)
    }

    return data.map((item) => {
      // 判断是不是多组合的子项，如果是多组合的子项的话不需要展示收藏按钮
      const canBeStar =
        level === 3 &&
        parentCategoryId !== categoryConfig.multiCustomCategory.id
      const newData = {
        ...item,
        id: item.id,
        pid: item.pid,
        name: getCategoryName(item),
        prefix: item.prefix,
        resource_type: item.resource_type,
        file_type: item.file_type,
        dco_part_id: item.dco_part_id,
        icon: item.icon,
        tag: item.tag,
        properties: item.properties,
        isFold: isFold(item),
        canBeStar,
        level,
      }

      // gameConfig 配置会配置 priority 属性，用于排序
      // desc 坑位描述
      if (item.resource_type === gameConfigCategoryResourceType) {
        newData.priority = item.priority
        newData.desc = item.desc
      }

      // 组
      if (item.resource_type === 'group' && Array.isArray(item.sub_category)) {
        const visible = () => {
          return item.sub_category.length > 0
        }
        return {
          ...newData,
          // 拓展内容一直展示
          visible: visible(),
          disabled: level === 1,
          // 组子项
          sub_category: item.sub_category
            ? rec(item.sub_category, {
                level: level + 1,
                // 这个 id 与 pid 不一定一样，如收藏和多组合的子项其 pid 与这里的 parentCategoryId 不一样，pid 指向的是原始数据的 pid，但是数据结构上的父级分类是收藏或多组合
                parentCategoryId: item.id,
              })
            : [],
        }
      }

      // 分类
      if (Array.isArray(item.sub_category)) {
        const visible = () => {
          // 收藏分类根据是否有权限决定是否展示
          if (isElementStars(item.id) || isGameConfigStars(item.id)) {
            return hasPermission({ key: 'category.star', permissionKeys })
          }
          if (isExpandedContent(item.id)) {
            return hasPermission({
              key: 'category.expanded-content',
              permissionKeys,
            })
          }
          return item.sub_category.length > 0
        }

        return {
          ...newData,
          // 拓展内容一直展示
          visible: visible(),
          disabled: level === 1,
          sub_category: rec(item.sub_category, {
            level: level + 1,
            // 这个 id 与 pid 不一定一样，如收藏和多组合的子项其 pid 与这里的 parentCategoryId 不一样，pid 指向的是原始数据的 pid
            // parentCategory 指向的是当前的父级 category
            parentCategoryId: item.id,
          }),
        }
      }

      const getVisible = () => {
        // json gameConfig
        if (item.resource_type === gameConfigCategoryResourceType) {
          // 判断当前分类能不能在json_config找到对应的值
          if (['autoEndTime', 'colorConfig'].some((k) => k === item.prefix)) {
            return (
              !_.isUndefined(
                _.get(templateConfig, `json_config.${item.prefix}`),
              ) &&
              !_.isNull(_.get(templateConfig, `json_config.${item.prefix}`))
            )
          }

          // 判断当前分类能不能在mw_config找到对应的值
          // 'yd_click', 'auto_click'
          if (['global_click'].some((k) => k === item.prefix)) {
            return _.isNumber(_.get(templateConfig, `mw_config.${item.prefix}`))
          }

          if (item.resource_type === gameConfigCategoryResourceType) {
            return (
              // v1 难度模式
              _.get(templateConfig, `json_config.${item.prefix}`) !==
                'undefined' ||
              // v2、v3 难度模式
              _.isArray(_.get(gameConfigResource, `gameDifficultyList`))
            )
          }
        }

        // 代码字，默认返回 true，不去判断代码字中的配置是否有这个值
        if (
          isLang({
            prefix: item.prefix,
            resourceType: item.resource_type,
          })
        ) {
          return true
        }

        if (isExpandedContent(item.id)) {
          // 素材仓库的拓展内容一直展示
          if (isMaterialWarehouse()) return true
          // pt 默认不展示
          return false
        }

        // 普通资源
        return !_.isEmpty(_.get(templateConfig, `resource.${item.id}`))
      }

      return {
        ...newData,
        disabled: level === 1,
        visible: getVisible(),
      }
    })
  }

  return rec(_.cloneDeep(category), {
    level: 1,
  })
}
